<template>
  <div class="main-market">
    <div class="market">
      <div class="type">
        <span class="title-1">نگاه کلی به بازار</span>
        <div class="buttons">
          <button @click="cryptofn" class="solid-gray-btn" :class="{'gray-btn' : select === 'crypto'}">
            رمز ارز
          </button>

          <button @click="goldfn" class="solid-gray-btn" :class="{'gray-btn' : select === 'gold'}">
            طلا و سکه
          </button>
        </div>
      </div>
      <div class="sort">
        <span class="title-2">مرتب سازی بر اساس</span>
        <div class="buttons">
          <button @click="topvaluefn()" :class="{'gray-btn' : sort === 'topvalue'}"
                  class="solid-gray-btn solid-gray-btn-custom-2">بالاترین حجم معاملات
          </button>
          <button @click="toppricefn()" :class="{'gray-btn' : sort === 'topprice'}"
                  class="solid-gray-btn solid-gray-btn-custom-2">بالاترین افزایش قیمت
          </button>
        </div>
      </div>
      <div class="table">
        <table>
          <tr class="no-hover">
            <th>
              ارز
            </th>
            <th class="hide992">
              قیمت لحظه ایی
            </th>
            <th>
              تغییرات (24h)
            </th>
            <th class="hide400">
              حجم
            </th>
            <th class="hide992">
              نمودار
            </th>
            <th class="btn-th" v-if="select !=='gold'">
              <button @click="usdtFn()" :class="{'gray-btn' : $store.state.type === 'usdt'}"
                      class="solid-gray-btn solid-gray-btn-custom-3"> تتر | USDT
              </button>
              <button @click="tomanFn()" :class="{'gray-btn' : $store.state.type === 'toman'}"
                      class="solid-gray-btn solid-gray-btn-custom-3">TMN | تومان
              </button>
            </th>
          </tr>

          <template v-if="select === 'crypto'">
            <template v-if="$store.state.type=='toman'">
              <tr v-for="(item , index) in $store.state.market.slice(0,8)" :key="index">
                <td>
                  <div class="name-coin">

                    <img class="hide992"
                         :src="require('../../assets/coins/'+$coinsUnit[item.relatedCoin.toUpperCase()]+'.svg')"
                         alt="item.relatedCoin">

                    <div class="name">
                      <p class="p-name">{{ $coinLabel[item.relatedCoin] }}</p>
                      <small class="relate-coin hide992">{{ $coinsUnit[item.relatedCoin.toUpperCase()] }}</small>
                    </div>
                  </div>
                </td>

                <td>{{ $toLocal(item.lastPrice, 0) }}</td>
                <td class="hide992 number"
                    :class="{'red':item.last24HourChange <= 0 , 'green':item.last24HourChange > 0}">
                  {{ $toLocal(item.last24HourChange, $decimal['TOMAN']) + '%' }}
                </td>
                <td class="hide400">{{ $toLocal(item.last24HourVolume, $decimal['TOMAN']) }}</td>
                <td class="hide992">
                  <div class="chart-td">
                    <apex-chart v-if="item.last24HourChange>=0" height="60" type="area" :options="chartOptions"
                                :series="[{
                    data:item.lastWeekData
                  }]"></apex-chart>
                    <apex-chart v-if="item.last24HourChange<0" height="60" type="area" :options="chartOptionsNeg"
                                :series="[{
                    data:item.lastWeekData
                  }]"></apex-chart>
                  </div>
                </td>
                <td class="btn-td">
                  <button @click.prevent="$router.push(`/trade/TOMAN/${$coin2Snake[item.relatedCoin]}`)"
                          class="blue-btn custom-blue-btn">Trade
                  </button>
                </td>
              </tr>
            </template>
            <template v-if="$store.state.type=='usdt'">
              <tr v-for="(item , index) in $store.state.marketUSDT.filter(a=>a.coin !== 'tether').slice(0,8)"
                  :key="index">
                <td>
                  <div class="name-coin">

                    <img class="hide992"
                         :src="require('../../assets/coins/'+$coinsUnit[item.relatedCoin.toUpperCase()]+'.svg')"
                         alt="item.relatedCoin">

                    <div class="name">
                      <p class="p-name">{{ $coinLabel[item.relatedCoin] }}</p>
                      <small class="relate-coin hide992">{{ $coinsUnit[item.relatedCoin.toUpperCase()] }}</small>
                    </div>
                  </div>
                </td>

                <td>{{ $toLocal(item.lastPrice, $decimal['TETHER']) }}</td>

                <td class="hide992 number"
                    :class="{'red':item.last24HourChange <= 0 , 'green':item.last24HourChange > 0}">
                  {{ $toLocal(item.last24HourChange, 2) + '%' }}
                </td>
                <td class="hide400">{{ $toLocal(item.last24HourVolume, $decimal['TOMAN']) }}</td>
                <td class="hide992">
                  <div class="chart-td">
                    <apex-chart v-if="item.last24HourChange>=0" height="60" type="area" :options="chartOptions"
                                :series="[{
                    data:item.lastWeekData
                  }]"></apex-chart>
                    <apex-chart v-if="item.last24HourChange<0" height="60" type="area" :options="chartOptionsNeg"
                                :series="[{
                    data:item.lastWeekData
                  }]"></apex-chart>
                  </div>
                </td>
                <td class="btn-td">
                  <button @click.prevent="$router.push(`/trade/TETHER/${$coin2Snake[item.relatedCoin]}`)" class="blue-btn cus
                  tom-blue-btn">Trade
                  </button>
                </td>
              </tr>
            </template>
          </template>

          <template v-if="select === 'gold'">
            <tr v-for="(item , index) in goldData.slice(0 , 8)" :key="index">
              <td>
                <div class="name-coin">
                  <img class="hide992" :src="require('../../assets/coins/'+item.logo+'.svg')" alt="item.relatedCoin">
                  <div class="name">
                    <p class="p-name">{{ item.name }}</p>
                    <small class="relate-coin hide992">{{ item.relatedCoin }}</small>
                  </div>
                </div>
              </td>

              <td v-if="type === 'usdt'">{{ item.usdtprice.toLocaleString() }}</td>
              <td v-if="type === 'toman'">{{ item.tomanprice.toLocaleString() }}</td>

              <td class="hide992 number" :class="{'red':item.lastChange < 0 , 'green':item.lastChange > 0}">
                {{ item.lastChange + '%' }}
              </td>
              <td class="hide400">{{ item.value.toLocaleString() }}</td>
              <td class="hide992">
                <div class="chart-td">
                  <svg
                      v-if="item.lastChange > 0"
                      class="svg"
                      aria-hidden="true"
                      focusable="false"
                  >
                    <defs>
                      <linearGradient id="btcFill1" x1="1" x2="1" y1="0" y2="1">
                        <stop offset="0%" stop-color="rgba(24, 160, 251, 0)"/>
                        <stop offset="100%" stop-color="rgba(24, 160, 251, 1)"/>
                      </linearGradient>
                    </defs>
                  </svg>
                  <TrendChart
                      v-if="item.lastChange > 0"
                      :datasets="[
    {
      data: [10, 50, 20, 100, 40, 60, 80],
      smooth: true,
      fill: true,
      className:'curveBlue'
    }
  ]"
                      :grid="{
     verticalLines: true,
     horizontalLines: true
  }"
                      :min="0">

                  </TrendChart>

                  <svg
                      v-if="item.lastChange < 0"
                      class="svg"
                      aria-hidden="true"
                      focusable="false"
                  >
                    <defs>
                      <linearGradient id="btcFill2" x1="1" x2="1" y1="0" y2="1">
                        <stop offset="0%" stop-color="rgba(184, 76, 76, 1)"/>
                        <stop offset="100%" stop-color="rgba(250, 17, 185, 0)"/>
                      </linearGradient>
                    </defs>
                  </svg>
                  <TrendChart
                      v-if="item.lastChange < 0"
                      :datasets="[
    {
      data: [10, 50, 20, 100, 40, 60, 80],
      smooth: true,
      fill: true,
       className:'curveRed'
    }
  ]"
                      :grid="{
     verticalLines: true,
     horizontalLines: true
  }"
                      :min="0">

                  </TrendChart>
                </div>
              </td>
              <td class="btn-td">
                <button @click="Error" class="blue-btn custom-blue-btn">Trade</button>
              </td>
            </tr>
          </template>

        </table>
      </div>
      <div @click="$router.push('/market')" class="link-to-market">
                <p class="market-link">مشاهده همه کوین‌ها</p>
        <img src="../../assets/Home/perv.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-market-table",
  data() {
    return {

      // series: [{
      //   data: [
      //     0,13,20,23,20,7,
      //     20,13,20
      //
      //   ]
      // }],
      chartOptions: {
        chart: {
          height: '30',
          sparkline: {
            enabled: true,
          }
        },
        stroke: {
          width: 2,
          // curve: 'smooth'
        },
        tooltip: {
          enabled: false
        },


        colors: ['transparent'],

        fill: {
          colors: ['rgba(24, 160, 251, 1)'],
          type: 'gradient',
          gradient: {
            opacityFrom: 1,
            opacityTo: 0,
            stops: [0, 100]
          }
        },


      },
      chartOptionsNeg: {
        chart: {
          height: '30',
          sparkline: {
            enabled: true,
          }
        },
        stroke: {
          width: 2,
          // curve: 'smooth'
        },
        tooltip: {
          enabled: false
        },


        colors: ['transparent'],

        fill: {
          colors: ['rgba(184, 76, 76, 1)'],
          type: 'gradient',
          gradient: {
            opacityFrom: 1,
            opacityTo: 0,
            stops: [0, 100]
          }
        },


      },
      select: 'crypto',
      sort: 'topvalue',
      type: 'usdt',
      show: false,
      //th data
      thData: [
        {name: 'ارز', show: false},
        {name: 'قیمت لحظه ایی', show: false},
        {name: 'تغییرات (24h)', show: true},
        {name: 'حجم', show: false},
        {name: 'نمودار', show: true},
      ],
      tableTether: [],
      tableData: [],
      tableToman: [],
      goldData: [],

      //data table
      dataTable: [
        {
          name: 'بیت کوین',
          tomanprice: 123456789,
          usdtprice: 152135887,
          relatedCoin: 'BTC',
          logo: 'BTC',
          lastChange: '+3.2',
          value: 123456789
        },
        {
          name: 'دوج کوین',
          tomanprice: 123456789,
          usdtprice: 252135887,
          relatedCoin: 'DOGE',
          logo: 'DOGE',
          lastChange: '-4.2',
          value: 133456789
        },
        {
          name: 'بایننس کوین',
          tomanprice: 123456789,
          usdtprice: 352135887,
          relatedCoin: 'BNB',
          logo: 'BNB',
          lastChange: '+1.2',
          value: 143456789
        },
        {
          name: 'اتریوم',
          tomanprice: 123456789,
          usdtprice: 452135887,
          relatedCoin: 'ETH',
          logo: 'ETH',
          lastChange: '-5.2',
          value: 153456789
        },
        {
          name: 'بیت کوین کش',
          tomanprice: 123456789,
          usdtprice: 552135887,
          relatedCoin: 'BCH',
          logo: 'BCH',
          lastChange: '+6.2',
          value: 163456789
        },
        {
          name: 'استلار',
          tomanprice: 123456789,
          usdtprice: 652135887,
          relatedCoin: 'XLM',
          logo: 'XLM',
          lastChange: '-7.2',
          value: 173456789
        },
        {
          name: 'ریپل',
          tomanprice: 123456789,
          usdtprice: 752135887,
          relatedCoin: 'XPR',
          logo: 'XPR',
          lastChange: '-2.2',
          value: 183456789
        },
        {
          name: 'ترون',
          tomanprice: 123456789,
          usdtprice: 852135887,
          relatedCoin: 'TRON',
          logo: 'TRON',
          lastChange: '+8.2',
          value: 193456789
        },
        {
          name: 'سلو',
          tomanprice: 123456789,
          usdtprice: 952135887,
          relatedCoin: 'CELO',
          logo: 'CELO',
          lastChange: '-5.2',
          value: 223456789
        },
        {
          name: 'لایت کوین',
          tomanprice: 123456789,
          usdtprice: 162135887,
          relatedCoin: 'LTC',
          logo: 'LTC',
          lastChange: '+9.2',
          value: 233456789
        },
        {
          name: 'ماتیک',
          tomanprice: 123456789,
          usdtprice: 272135887,
          relatedCoin: 'MATIC',
          logo: 'MATIC',
          lastChange: '-1.2',
          value: 243456789
        },
        {
          name: 'تتر',
          tomanprice: 123456789,
          usdtprice: 382135887,
          relatedCoin: 'USDT',
          logo: 'USDT',
          lastChange: '-2.2',
          value: 253456789
        },
      ],

      GoldDataTable: [
        {
          name: 'گرم',
          tomanprice: 123456789,
          usdtprice: 152135887,
          relatedCoin: 'geram',
          logo: 'geram',
          lastChange: '+3.2',
          value: 123456789
        },
        {
          name: 'مثقال',
          tomanprice: 123456789,
          usdtprice: 252135887,
          relatedCoin: 'mesghal',
          logo: 'mesghal',
          lastChange: '-4.2',
          value: 133456789
        },
        {
          name: 'سکه تمام',
          tomanprice: 123456789,
          usdtprice: 352135887,
          relatedCoin: 'tamam',
          logo: 'tamam',
          lastChange: '+1.2',
          value: 143456789
        },
        {
          name: 'نیم سکه',
          tomanprice: 123456789,
          usdtprice: 452135887,
          relatedCoin: 'nim',
          logo: 'nim',
          lastChange: '-5.2',
          value: 153456789
        },
        {
          name: 'تمام سکه',
          tomanprice: 123456789,
          usdtprice: 552135887,
          relatedCoin: 'tamam',
          logo: 'tamam',
          lastChange: '+6.2',
          value: 163456789
        },
      ]

    }
  },
  watch: {
    'setcoins'() {
      let usd;
      let usdt
      usd = this.$store.state.market
      usdt = this.$store.state.marketUSDT
      this.tableToman = usd
      this.tableTether = usdt
      this.show = true;

      this.state.loading = false;

    },
  },
  methods: {
Error(){
  console.log('hi')
  this.$error('', 'در حال حاضر این قابلیت در دسترس نیست', 'error','','','3000');
},

    goto(e) {
      // console.log(e)
    },


    // gotoMarket(e) {
    //   alert(e)
    //   console.log(e)
    //   this.$router.push('/trade/' + (this.$store.state.type === 'toman' ? 'TOMAN' : 'TETHER') + `/${e}`)
    // },

    topvaluefn() {
      let data = this.$store.state.market;
      let dataUSDT = this.$store.state.marketUSDT
      let gold = this.GoldDataTable
      data.sort((a, b) => b.last24HourChange - a.last24HourChange);
      dataUSDT.sort((a, b) => b.last24HourChange - a.last24HourChange);
      gold.sort((a, b) => b.last24HourChange - a.last24HourChange);
      this.tableToman = data;
      this.goldData = gold;
      this.tableTether = dataUSDT;
      this.sort = 'topvalue'
    },

    toppricefn() {
      let data = this.$store.state.market;
      let gold = this.GoldDataTable
      let dataUSDT = this.$store.state.marketUSDT
      data.sort((a, b) => b.lastPrice - a.lastPrice);
      dataUSDT.sort((a, b) => b.lastPrice - a.lastPrice);
      // data.sort((a, b) => b.lastPrice - a.lastPrice);
      gold.sort((a, b) => b.lastPrice - a.lastPrice);
      // gold.sort((a, b) => b.lastPrice - a.lastPrice);
      this.tableToman = data;
      this.goldData = gold;
      this.tableTether = dataUSDT;
      this.sort = 'topprice'
    },

    cryptofn() {
      this.select = 'crypto'
    },

    goldfn() {
      this.select = 'gold'
    },

    usdtFn() {
      this.$store.commit('changeType', 'usdt')
      console.log(this.$store.state.type)

    },

    tomanFn() {
      this.$store.commit('changeType', 'toman')
      console.log(this.$store.state.type)

    },


    setTables() {
      this.tableToman = this.$store.state.market;
      this.tableTether = this.$store.state.marketUSDT;
    },


  },

  mounted() {
    this.setTables()
    this.topvaluefn()
    this.state.loading = true;

  }
}
</script>


<style lang="scss" scoped>
//general class
.gray-btn {
  background: rgba(215, 200, 200, 0.12) !important;
  border-radius: 4px !important;
  color: rgba(17, 153, 250, 1) !important;
  cursor: pointer !important;
  font-size: clamp(10px, 2vw, 12px) !important;
  height: auto;
  width: auto;
}

.public-row {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 22px;
  flex-wrap: wrap;
}

.buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;

  button {
    width: 92px;
    height: 32px;
  }
}

//class
.main-market {
  display: flex;
  justify-content: center;
  width: 100%;
  direction: rtl;

  .market {
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 80%;
    align-items: start;

    .type {
      @extend .public-row;

      .gray-btn-custom-1 {
        width: 92px;
        height: 32px;
      }

      .solid-gray-btn-custom-1 {
        width: 92px;
        height: 32px;
      }

      .title-1 {
        font-size: clamp(14px, 2vw, 20px);
        font-weight: bold;
        color: #FBFBFD;
      }
    }

    .sort {
      @extend .public-row;

      .title-2 {
        font-size: clamp(12px, 2vw, 16px);
        font-weight: bold;
        color: #D7C8C8;
      }

      .gray-btn-custom-2 {
        width: 140px;
        height: 32px;
      }

      .solid-gray-btn-custom-2 {
        width: 140px;
        height: 32px;
      }
    }

    .table {
      flex-grow: 1;

      table {
        color: #FFFFFF;

        tr {
          height: 42px;

          &:hover {
            cursor: pointer;
            background: linear-gradient(259.33deg, rgba(28, 52, 102, 0) 7.64%, rgba(28, 52, 102, 0.35) 52.12%, rgba(20, 37, 69, 0.24) 83.62%);
          }
        }

        .no-hover {

        }
      }

      .name-coin {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;

        img {
          width: 30px;
        }

        .name {
          display: flex;
          flex-direction: column;
          gap: 0;


          .p-name {
            font-size: clamp(12px, 2vw, 16px);
            color: #FBFBFD;
          }

          .relate-coin {
            font-size: clamp(8px, 2vw, 10px);
            color: rgba(215, 200, 200, 1);
          }
        }
      }

      .chart-td {
        width: 70%;
        height: 42px;
      }

      .svg {
        position: absolute;
        width: 0 !important;
        height: 0 !important;
      }

      .btn-td {
        text-align: end;
      }

      .btn-th {
        display: flex;
        gap: 10px;
        justify-content: end;
        height: inherit;
        align-items: center;
      }

      .gray-btn-custom-3 {
        width: 92px;
        height: 32px
      }

      .solid-gray-btn-custom-3 {
        width: 92px;
        height: 32px
      }

      .custom-blue-btn {
        width: 121px;
        height: 37px;
        font-size: clamp(14px, 2vw, 16px);
        padding: 9px 0;
      }
    }

    .link-to-market {
      display: flex;
      flex-grow: 1;
      width: 100%;
      justify-content: end;
      align-items: center;
      gap: 10px;
      cursor: pointer;

      .market-link {
        color: #1199FA;
        font-size: clamp(14px, 2vw, 18px);
      }
    }
  }
}

@media (max-width: 992px) {
  .hide992 {
    display: none !important;
  }

  .custom-blue-btn {
    width: 70% !important;
    height: 30px !important;
  }

  .gray-btn-custom-3 {
    background-color: transparent !important;
    border: none !important;
  }

  .solid-gray-btn-custom-3 {
    background-color: transparent !important;
    border: none !important;
  }
}

@media (max-width: 450px) {
  .hide400 {
    display: none !important;
  }
}
</style>

<style>
.curveBlue .fill {
  fill: url('#btcFill1');
}

.curveBlue .stroke {
  stroke: rgba(17, 153, 250, 0) !important;
  stroke-width: 2 !important;
}

.curveRed .fill {
  fill: url('#btcFill2');
}

.curveRed .stroke {
  stroke: rgba(250, 17, 185, 0) !important;
  stroke-width: 2 !important;
}
</style>